import React from "react";

const VideoIcon = (props) => (
  <svg
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={24}
    height={20}
    viewBox="0 0 24 20"
    style={{
      verticalAlign: "bottom",
    }}
    {...props}
  >
    <defs>
      <rect id="a" width={180} height={41} y={10} rx={4} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-53 -21)">
        <use fill="#FFF" xlinkHref="#a" />
        <rect width={179} height={40} x={0.5} y={10.5} stroke="#F2F2F2" rx={4} />
      </g>
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M18.5 0h-13A5.506 5.506 0 0 0 0 5.5v9C0 17.533 2.467 20 5.5 20h13c3.033 0 5.5-2.467 5.5-5.5v-9C24 2.467 21.533 0 18.5 0zm-1.729 10.42l-7 4.5a.495.495 0 0 1-.511.019A.501.501 0 0 1 9 14.5v-9a.501.501 0 0 1 .77-.42l7 4.5a.498.498 0 0 1 .001.84z"
      />
    </g>
  </svg>
);

export default VideoIcon;
